const normalize = value => String(value ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/\s+/g, " ").trim();
export function planningEntity(contract, view) {
  const name = String(view === "worker" ? contract.NomPrenom || "Intérimaire non renseigné" : contract.RaisonSociale || "Client non renseigné").trim();
  const rawId = view === "worker" ? contract.IdInterimaire : contract.IdClient;
  const usableId = ["string", "number"].includes(typeof rawId) && normalize(rawId) !== "" && String(rawId) !== "0";
  return { id: `${view}:${usableId ? `id:${rawId}` : `name:${normalize(name)}`}`, name };
}
export function matchesPlanningSearch(contract, search) {
  const text = normalize([contract.NomPrenom, contract.RaisonSociale, contract.NumeroContrat].join(" "));
  return normalize(search).split(" ").filter(Boolean).every(word => text.includes(word));
}
export function planningOptions(contracts, view) {
  const map = new Map();
  contracts.forEach(contract => { const entity = planningEntity(contract, view); map.set(entity.id, entity); });
  return Array.from(map.values()).sort((a,b) => a.name.localeCompare(b.name, "fr"));
}
